import { defineMessages } from 'react-intl';

export const templateFormMessages = defineMessages({
  nameInputLabel: {
    id: 'templates.templateForm.nameInputLabel',
    defaultMessage: 'Tailoring Proposal name',
    description: 'Template form name input label',
  },
  nameInputPlaceholder: {
    id: 'templates.templateForm.nameInputPlaceholder',
    defaultMessage: 'Enter Tailoring Proposal name',
    description: 'Template form name input placeholder',
  },
  descriptionInputLabel: {
    id: 'templates.templateForm.descriptionInputLabel',
    defaultMessage: 'Tailoring Proposal description',
    description: 'Template form description input label',
  },
  descriptionInputPlaceholder: {
    id: 'templates.templateForm.descriptionInputPlaceholder',
    defaultMessage: 'Enter Tailoring Proposal description',
    description: 'Template form description input placeholder',
  },
  productSelectLabel: {
    id: 'templates.templateForm.productSelectLabel',
    defaultMessage: 'Product',
    description: 'Template form product select label',
  },
  productSelectPlaceholder: {
    id: 'templates.templateForm.productSelectPlaceholder',
    defaultMessage: 'Choose Product',
    description: 'Template form product select placeholder',
  },
  submitButton: {
    id: 'templates.templateForm.submitButton',
    defaultMessage: 'Submit',
    description: 'Template form submit button',
  },
  backButton: {
    id: 'templates.templateForm.backButton',
    defaultMessage: 'Cancel',
    description: 'Template form back button',
  },

  addTemplateDialogTitle: {
    id: 'templates.dialog.addTemplateTitle',
    defaultMessage: 'New Tailoring Proposal',
    description: 'Add template dialog title',
  },
  editTemplateDialogTitle: {
    id: 'templates.dialog.editTemplateTitle',
    defaultMessage: 'Edit Tailoring Proposal',
    description: 'Edit template dialog title',
  },

  addTemplateToast: {
    id: 'templates.toast.addTemplate',
    defaultMessage: 'Tailoring Proposal successfully added.',
    description: 'Template added toast',
  },
  editTemplateToast: {
    id: 'templates.toast.editTemplate',
    defaultMessage: 'Tailoring Proposal successfully edited.',
    description: 'Template edited toast',
  },
  deleteTemplateToast: {
    id: 'templates.toast.deleteTemplate',
    defaultMessage: 'Tailoring Proposal successfully deleted.',
    description: 'Template deleted toast',
  },
});
